<template>
<canvas class="w-100 bg-secondary">
    <p>Your browser does not support the HTML5 canvas tag.</p>
</canvas>
</template>

<script>
import SignaturePad from 'signature_pad';

export default {
    name: "FormSubmittableSignature",
    props: {
        form: Object,
    },
    computed: {
        canvas() {
            return document.querySelector('canvas');
        },
        signature_pad() {
            return new SignaturePad(this.canvas);
        },
    },
    mounted() {
        this.canvas.width = 400;
        this.canvas.height = 400;

        window.addEventListener('resize', this.resizeCanvas);
    },
    methods: {
        resizeCanvas() {
            const ratio = Math.max(window.devicePixelRatio || 1, 1);
            this.canvas.width = this.canvas.offsetWidth * ratio;
            this.canvas.height = this.canvas.offsetHeight * ratio;
            this.canvas.getContext('2d').scale(ratio, ratio);
            this.signature_pad.clear();
        },
        isSignatureEmpty() {
            return this.signature_pad.isEmpty();
        }
    }
}
</script>
